import { NamesOfFieldEnum, NameStepsEnumCustomerV2 } from "~/typings/types";
import { isDev } from "./isDev";
import { sanitizeData } from "./sanitizeData";
import { ENV_IS_ENABLED_ROISTAT } from "~/configs/consts";

const configEventsByStep: Record<string, string> = {
  step0: "anketa_legalform_filled", // выбрал правовую форму
  [NameStepsEnumCustomerV2.AccountDetails]: "anketa_profile_registered", // профиль зарегистрирован
  [NameStepsEnumCustomerV2.CompanyDetails]: "anketa_requisites_filled", // заполнил реквизиты
  [NameStepsEnumCustomerV2.PayformTechDetails]: "anketa_pfdata_filled", // ввел данные по ПС
  [NameStepsEnumCustomerV2.AdditionalDetails]: "anketa_addinfo_filled", // заполнил доп.сведения
  [NameStepsEnumCustomerV2.AttachmentsDetails]: "anketa_sent" // отправлена (после загрузки документов)
};

export const sendAnalitics = (step: string, values?: Record<string, string>) => {
  try {
    if (isDev || ENV_IS_ENABLED_ROISTAT === "false") {
      return;
    }

    if (values) {
      window.roistat?.event.send(configEventsByStep?.[step], {
        "Full name": sanitizeData(
          `${values?.[NamesOfFieldEnum.CrmNameFirst]} ${values?.[
            NamesOfFieldEnum.CrmNameLast
          ]} ${values?.[NamesOfFieldEnum.CrmNamePatron]}`
        ),
        Email: sanitizeData(values?.[NamesOfFieldEnum.CrmEmail]),
        Phone: sanitizeData(values?.[NamesOfFieldEnum.CrmPhone])
      });
    } else {
      window.roistat?.event.send(sanitizeData(configEventsByStep[step]));
    }
  } catch {
    // TODO: send backend error event log
    return;
  }
};
